var BH_DARK_THEME_COLOR  = '#1A1918';
var BH_LIGHT_THEME_COLOR = '';

function bhApplyTheme(newTheme) {
  document.documentElement.classList.remove('dark-mode', 'light-mode');
  document.documentElement.classList.add(newTheme + '-mode');

  var meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', newTheme === 'dark' ? BH_DARK_THEME_COLOR : BH_LIGHT_THEME_COLOR);

  document.dispatchEvent(new CustomEvent('theme:change', { detail: { theme: newTheme } }));
}

document.addEventListener('DOMContentLoaded', function() {
  var themeToggle = document.querySelector('.theme-toggle');
  if (themeToggle) {
    themeToggle.addEventListener('click', function() {
      var newTheme = document.documentElement.classList.contains('dark-mode') ? 'light' : 'dark';
      bhApplyTheme(newTheme);
      try {
        localStorage.setItem('shopify-theme-mode', newTheme);
      } catch (e) {
        console.error('Failed to save theme preference to localStorage:', e);
      }
    });
  }

  // Follow system preference changes if the user has not made an explicit choice
  var systemDark = window.matchMedia('(prefers-color-scheme: dark)');
  systemDark.addEventListener('change', function(e) {
    var saved = null;
    try { saved = localStorage.getItem('shopify-theme-mode'); } catch (_) {}
    if (saved) return; // respect explicit user choice

    bhApplyTheme(e.matches ? 'dark' : 'light');
  });
});
